import moment from 'moment';
import React from 'react'
import { WithdrawStatusCell, getWithdrawRowStatus } from './withdrawStatus';

export const BankTableRow = (props) => {
  const { netValue, user, createdAt, bank, WithdrawRequest, accountName, accountNumber } = props;
  const status = getWithdrawRowStatus(props)
  const request = Array.isArray(WithdrawRequest) ? WithdrawRequest[0] : null
  const bankInfo = bank || (request && request.Bank) || (user && user.bank)
  const holderName = accountName || (request && request.accountName) || (user && user.bankAccountName) || ''
  const holderNumber = accountNumber || (request && request.accountNumber) || (user && user.bankAccountNumber) || ''

  const datedString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  return (
    <tr className='text-center'>
      <td>
        {(user && user.name) || ""}<br />
        <span ><strong className={`text-primary`}>{(user && user.phone) || ""}</strong></span>
      </td>
      <td className={`text-center ${status.reverted ? 'text-danger' : ''}`}>
        {new Intl.NumberFormat('vn-VI', {}).format(netValue) || ""}
      </td>
      <td className='text-center'>
        <strong>{(bankInfo && bankInfo.shortName) || ''}</strong>
        {holderName ? (<><br /><span>{holderName}</span></>) : null}
        {holderNumber ? (<><br /><span className="text-success">{holderNumber}</span></>) : null}
      </td>
      <WithdrawStatusCell {...props} />
      <td>{datedString}</td>
    </tr>
  );
}
